import React from 'react';
import { SparkDialog } from 'sharedComponents/UI';
import Editor from './Editor';
type Props = {
  open: boolean;
  onClose: () => void;
  getCroppedImage?: (file: File | null | undefined, url: string) => void;
  imageSrc: string;
  aspectRatio?: number;
};
export function EditorModal({
  onClose,
  open,
  getCroppedImage,
  imageSrc,
  aspectRatio = 1,
}: Props) {
  return (
    <SparkDialog onClose={onClose} open={open} title='Crop Image'>
      <Editor
        onClose={onClose}
        imageSrc={imageSrc}
        getCroppedImage={getCroppedImage}
        aspectRatio={aspectRatio}
      />
    </SparkDialog>
  );
}
